import { animate } from 'animejs';

class Module05Logos {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      bandeau();
    }

    let initCache = () => {
      cache.bandeau = document.querySelectorAll('.module-05-logo .bandeau');
    //   for (let i = 0; i < cache.bandeau.length; i++) {
    //     let bandeau = cache.bandeau[i];
    //     bandeau.style.width = bandeau.scrollWidth+"px";
    //   }
    }

    let bandeau = () => {
      for (let i = 0; i < cache.bandeau.length; i++) {
        let bandeau = cache.bandeau[i];
        animate(bandeau, {
            translateX: ['0%', '-100%'],
              duration: 8000,
              ease: 'linear',
              loop: true,
        });
      }

    }
    initFunc();
  }
}
export { Module05Logos }